import { Play, ChevronDown } from "lucide-react";
import { IMAGES } from "../data/content";

export const Hero = ({ onShowreel }) => (
  <section id="hero" data-testid="hero-section" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
    <div className="absolute inset-0">
      <img src={IMAGES.heroBg} alt="Futuristic city render" className="w-full h-full object-cover opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#070709] via-[#070709]/60 to-[#070709]/30" />
      <div className="absolute inset-0 lens-flare" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto w-full px-4 sm:px-8 lg:px-16 pt-28 pb-10">
      <p className="font-mono2 text-xs sm:text-sm tracking-[0.35em] text-amber-500/90 mb-6">
        KTH STUDIOS — VISUAL EFFECTS HOUSE — CHENNAI | BANGALORE
      </p>
      <h1 data-testid="hero-title" className="font-display text-6xl sm:text-8xl lg:text-9xl leading-[0.9] tracking-wide text-zinc-50">
        KINGDOM OF
        <br />
        <span className="text-stroke">THEATRICAL</span>
        <br />
        HORIZONS
      </h1>
      <p className="mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-zinc-300">
        Academy-level visual effects, photorealistic 3D/CGI, creature animation and complex
        environment simulation for feature films and high-end streaming.
      </p>
      <div className="mt-10 flex flex-wrap items-center gap-4">
        <button data-testid="hero-play-showreel-btn" onClick={onShowreel}
          className="glow-pulse flex items-center gap-3 bg-amber-500 text-[#070709] px-8 py-4 font-mono2 text-sm tracking-[0.2em] font-semibold hover:bg-amber-400 transition-colors">
          <Play className="w-4 h-4 fill-current" /> WATCH SHOWREEL
        </button>
        <button data-testid="hero-explore-work-btn"
          onClick={() => document.getElementById("work")?.scrollIntoView({ behavior: "smooth" })}
          className="flex items-center gap-3 border border-white/25 text-zinc-100 px-8 py-4 font-mono2 text-sm tracking-[0.2em] hover:border-amber-500 hover:text-amber-500 transition-colors">
          EXPLORE WORK <ChevronDown className="w-4 h-4" />
        </button>
      </div>

      <div data-testid="hero-stats-ribbon" className="mt-10 grid grid-cols-3 max-w-2xl divide-x divide-white/10 border-y border-white/10">
        {[["25+", "Feature Films"], ["50+", "Commercials / Ads"], ["99.9%", "Render On-Time"]].map(([n, l]) => (
          <div key={l} className="py-5 px-4 text-center">
            <div className="font-display text-3xl sm:text-4xl text-amber-500">{n}</div>
            <div className="font-mono2 text-[10px] sm:text-xs tracking-[0.2em] text-zinc-400 mt-1 uppercase">{l}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
